<template>
    <vue-modal :open="open">
        <div class="bax-modal-content bax-modal-icon-content text-center">
            <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
                <i class="icon-delete"></i>
            </div>
            <h2>Cancel new patient registration?</h2>
            <p>Are you sure? If you cancel this new patient registration, you will lose all the information you have entered.</p>
            <div class="bax-modal-action-items">
                <button type="button" class="bax-btn bax-btn-bordered-blue-brand" @click.prevent="cancelModal">No, take me back</button>
                <button type="button" class="bax-btn bax-btn-blue-brand" :class="{ 'loading': formSubmitting }" @click.prevent="deleteRecord">Yes, discard all the data</button>
                <!-- <router-link
                :to="{name: 'homeTPN', query: { registrationCancel: type }}"
                class="bax-btn bax-btn-blue-brand"
                >Yes, discard all the data</router-link> -->
            </div>
            <div class="feedback" v-if="error">
                {{error}}
            </div>
        </div>
    </vue-modal>
</template>
<script>

import PatientRegistationService from '@/core/api/tpn/patientRegistation.service';

export default {
    name: 'CancelRegistationModal',
    props: {
        open: {
            required: true,
        },
        type: {
            required: true,
        },
        patientFormId: {
            required: true,
        },
    },
    data() {
        return {
            formSubmitting: false,
            error: false,
        };
    },
    methods: {
        cancelModal() {
            this.$emit('modal_cancel_response');
        },
        deleteRecord() {
            if (!this.formSubmitting) {
                this.formSubmitting = true;
                this.error = false;
                if (this.patientFormId) {
                    PatientRegistationService.deletePatientRegistation(this.patientFormId)
                    .then((res) => {
                        if (!res.data.deleted) {
                            this.error = 'Sorry, something went wrong';
                        } else {
                            this.$router.push({ name: 'homeTPN', query: { registrationCancel: this.type } });
                        }
                    });
                } else {
                    this.$router.push({ name: 'homeTPN', query: { registrationCancel: this.type } });
                }
            }
        },
    },
};
</script>
